import {Injectable} from '@angular/core';
import {CursorPaging, Department} from '@etop/models';
import {DepartmentAPI, DepartmentApi} from "@etop/api";
import {DepartmentStore} from "@etop/state/shop/department/department.store";
import {DepartmentQuery} from "@etop/state/shop/department/department.query";

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  constructor(
    private departmentApi: DepartmentApi,
    private departmentStore: DepartmentStore,
    private departmentQuery: DepartmentQuery,
  ) {
  }

  async getDepartments(){
    this.departmentStore.setLoading(true);
    try {
      const {filter, paging} = this.departmentQuery.Ui;
      const res = await this.departmentApi.getDepartments({filter, paging});
      const departments: Department[] = res.departments;
      this.setPaging(res.paging);
      this.departmentStore.set(departments);
    } catch (e) {
      debug.error("Error in getting departments");
    }
    this.departmentStore.setLoading(false);
  }

  setFilter(filter: DepartmentAPI.GetDepartmentsFilter) {
    const ui = this.departmentQuery.Ui;
    this.departmentStore.update({
      ui: {
        ...ui,
        filter
      }
    });
  }

  async getDepartmentsNoStore(filter?: DepartmentAPI.GetDepartmentsFilter, paging?: CursorPaging){
    try {
      return await this.departmentApi.getDepartments({filter, paging});
    } catch (e) {
      debug.error("Error in getting getDepartmentsNoStore");
    }
  }

  async createDepartment(request: DepartmentAPI.CreateDepartmentRequest) {
    return await this.departmentApi.createDepartment(request);
  }

  async deleteDepartment(id: String) {
    return await this.departmentApi.deleteDepartment(id);
  }

  async updateDepartment(request: DepartmentAPI.UpdateDepartmentRequest) {
    return await this.departmentApi.updateDepartment(request);
  }

  setPaging(paging: CursorPaging) {
    const ui = this.departmentQuery.Ui;
    this.departmentStore.update({
      ui: {
        ...ui,
        paging
      }
    });
  }

  setCurrentPage(currentPage: number) {
    const ui = this.departmentQuery.Ui;
    this.departmentStore.update({
      ui: {
        ...ui,
        currentPage: currentPage
      }
    });
  }

  setActive(id) {
    this.departmentStore.setActive(id);
  }
}
